interface FilterWrapperProps {
  children?: React.ReactNode;
  filterRef?: React.RefObject<HTMLDivElement>;
}

const FilterWrapper: React.FC<FilterWrapperProps> = ({
  children,
  filterRef,
}) => {
  return (
    <div
      ref={filterRef}
      className="inline-flex gap-4 items-center justify-start"
    >
      <div className="self-stretch py-1 flex-col opacity-50 justify-center items-start gap-2 inline-flex">
        <div className="grow shrink basis-0 w-px self-stretch bg-neutral-300" />
      </div>
      {children}
    </div>
  );
};

export default FilterWrapper;
